import { render, staticRenderFns } from "./EditCategorySidebar.vue?vue&type=template&id=2539bd3a"
import script from "./EditCategorySidebar.vue?vue&type=script&lang=js"
export * from "./EditCategorySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports